import { render } from "./Forget.vue?vue&type=template&id=b0a7c864"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"
script.render = render

export default script